import { Navigate } from 'react-router-dom';

import { Spinner } from '@/components/generic';
import { shouldEnforceFirebaseMfa } from '@/configuration/ssoProviders';
import { useAuth } from '@/contexts';
import { PUBLIC_PAGE_ROUTES } from '@/enums';
import { getDefaultPrivateRoute } from '@/helpers';

type MfaSetupRouteProps = {
  children: JSX.Element;
};

export const MfaSetupRoute = ({ children }: MfaSetupRouteProps) => {
  const { user, currentUserData, isAuthLoading, signInProvider } = useAuth();

  if (isAuthLoading || (user && signInProvider === null)) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={PUBLIC_PAGE_ROUTES.LOGIN} replace />;
  }

  if (!currentUserData?.isMfaForced || !shouldEnforceFirebaseMfa(signInProvider)) {
    return <Navigate to={getDefaultPrivateRoute(currentUserData)} replace />;
  }

  return children;
};
